import { render, staticRenderFns } from "./WxWorkBasicinfoPanel.vue?vue&type=template&id=78ed4eb4&scoped=true&"
import script from "./WxWorkBasicinfoPanel.vue?vue&type=script&lang=js&"
export * from "./WxWorkBasicinfoPanel.vue?vue&type=script&lang=js&"
import style0 from "./WxWorkBasicinfoPanel.vue?vue&type=style&index=0&id=78ed4eb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ed4eb4",
  null
  
)

export default component.exports